import { useNavigate } from 'react-router-dom'
import { Button, ButtonGroup, Flex, FormControl, FormLabel, Grid, HStack, Text, useDisclosure } from '@chakra-ui/react'

import FinishEvent from 'views/Events/Event/FinishEvent'
import CancelEvent from 'views/Events/Event/CancelEvent'

import FormCard from 'components/FormCard'
import Layout from 'components/ManagerLayout'
import LifeMissing from 'views/Events/Event/LifeMissing'

const Event = () => {
    const { isOpen: finishIsOpen, onOpen: finishOnOpen, onClose: finishOnClose } = useDisclosure()
    const { isOpen: cancelIsOpen, onOpen: cancelOnOpen, onClose: cancelOnClose } = useDisclosure()
    const { isOpen: missingIsOpen, onOpen: missingOnOpen, onClose: missingOnClose } = useDisclosure()

    const navigate = useNavigate()

    return (
        <Layout>
            <FormCard title="06/04/2023 - Fulano">
                <Flex direction="column" w="100%">
                    <Grid
                        w="full"
                        templateColumns={{ sm: "1fr", md: "repeat(2, 1fr)" }}
                        gap="24px"
                        mb="24px"
                    >
                        <FormControl>
                            <FormLabel
                                fontWeight="bold"
                                fontSize="xs"
                            >
                                Vida
                            </FormLabel>
                            <Text>Kekwomegalul</Text>
                        </FormControl>
                        <FormControl>
                            <FormLabel
                                fontWeight="bold"
                                fontSize="xs"
                            >
                                Médico
                            </FormLabel>
                            <Text>Jeej jooj</Text>
                        </FormControl>
                        <FormControl>
                            <FormLabel
                                fontWeight="bold"
                                fontSize="xs"
                            >
                                Espicialização
                            </FormLabel>
                            <Text>Clínico geral</Text>
                        </FormControl>
                        <FormControl>
                            <FormLabel
                                fontWeight="bold"
                                fontSize="xs"
                            >
                                Data e hora do agendamento
                            </FormLabel>
                            <Text>segunda feira, 10 de abril de 2023 às 10:00</Text>
                        </FormControl>
                    </Grid>
                    <Flex w="full" justifyContent="flex-end">
                        <HStack spacing={4}>
                            <Button variant="ghost" colorScheme="gray" size="md" onClick={() => navigate(-1)}>Voltar</Button>
                            <ButtonGroup size='md' isAttached>
                                <Button colorScheme="red" onClick={() => cancelOnOpen()}>Cancelar</Button>
                                <Button colorScheme="purple" onClick={() => missingOnOpen()}>Ausência</Button>
                                <Button colorScheme="green" onClick={() => finishOnOpen()}>Finalizar</Button>
                            </ButtonGroup>
                        </HStack>
                    </Flex>
                </Flex>
            </FormCard>
            <FinishEvent isOpen={finishIsOpen} onClose={finishOnClose} />
            <CancelEvent isOpen={cancelIsOpen} onClose={cancelOnClose} />
            <LifeMissing isOpen={missingIsOpen} onClose={missingOnClose} />
        </Layout>
    )
}

export default Event